import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";
import { GreenHomeBasisType } from "@models/map/market-filter.model";

export interface GreenHomeModel {
    greenHomeBasisType: GreenHomeBasisType;
    index: number;
    selected: boolean;
    description?: string;
}

const defaultGreenHomes: GreenHomeModel[] = [    
    { greenHomeBasisType: GreenHomeBasisType.EnergyLabelA, index: 0, selected: false, description: "Energimerke A" },
    { greenHomeBasisType: GreenHomeBasisType.Top15, index: 1, selected: false, description: "Topp 15%" },
    { greenHomeBasisType: GreenHomeBasisType.NZEB, index: 2, selected: false, description: "NZEB-10%" },    
];

export interface GreenHousingFilterModel {
    greenHomeBasisTypes: GreenHomeModel[];
    isGreenHome: boolean;
    expanded: boolean;
}

export function createGreenHousingModel() {
    return signal<GreenHousingFilterModel>({
        greenHomeBasisTypes: defaultGreenHomes,
        isGreenHome: false,
        expanded: false,
    });
}

export function buildGreenHousingModel(a: SchemaPathTree<GreenHousingFilterModel>) {}
